export default "__VITE_ASSET__BtBe5jN1__"